<template>
  <div>
    <div>
      <div v-if="!linkData.name" :class="linkData.divClass">
        <a :class="linkData.style.class">
          {{ linkData.value }}
        </a>
      </div>

      <div v-else :class="linkData.divClass">
        <div :class="linkData.style.divClassFirst">
          <p :class="linkData.style.class">
            {{ linkData.name }}
          </p>
        </div>
        <div :class="linkData.style.divClassSecond">
          <a :class="linkData.style.class">
            {{ linkData.value }}
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    linkData: {
      type: String
    }
  }
};
</script>

<style lang="scss"></style>
